export default function buildCoalLineConfig (xAxis, data) {
  return {
    tooltip: {
      trigger: 'axis',
      show: true
    },
    grid: {
      left: '0',
      bottom: '0',
      width: '90%',
      height: '90%',
      containLabel: true
    },
    color: ['#12C5C0'],
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLabel: {
        color: '#fff'
      },
      data: xAxis
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false
      },
      axisLabel: {
        color: '#FFF',
        formatter: '{value}'
      }
    },
    visualMap: [{
      show: false,
      type: 'continuous',
      seriesIndex: 0,
      min: 0,
      max: 400,
      backgroundColor: '#12C5C0',
      inRange: {
        color: ['#15AEFE', 'rgba(255,255,255,0.4)', '#DBFA76'],
        symbolSize: [5, 12]
      }
    }],
    series: [
      {
        type: 'line',
        smooth: true,
        data: data,
        areaStyle: {}
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/config/chart/config_coal_line.js